import React from 'react';
import { CopyToClipboard } from '@/components/common/copyToClipboard';
import { copyToClipboard } from '@/utils';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'aha-components';

export default function PromotionalLinkCopy({
  utmLink,
  constrainToContainer = false
}: {
  utmLink: string;
  constrainToContainer?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip
        className={constrainToContainer ? 'max-w-full' : undefined}
        content={
          utmLink ? utmLink : t('ModalPromotionalLinkEducation.promotionalLink')
        }
      >
        <div
          className={`inline-flex gap-[6px] h-[22px] items-center rounded-[8px] w-fit mx-2 ${constrainToContainer ? 'max-w-[calc(100%-1rem)]' : ''} ${utmLink ? 'bg-[#EFF6FF] px-2' : ''}`}
        >
          <div
            className={`cursor-pointer min-w-0 max-w-[260px] truncate justify-center text-sm font-[600] leading-snug ${utmLink ? 'text-[#155DFC]' : 'text-[#1C2024]'}`}
          >
            {utmLink
              ? utmLink
              : t('ModalPromotionalLinkEducation.promotionalLink')}
          </div>
          {utmLink && (
            <CopyToClipboard
              onClick={() => {
                copyToClipboard(utmLink);
                toast.success(
                  t('brandResources.promotionalLinkCopied', {
                    defaultValue: 'Promotional link copied.'
                  })
                );
              }}
            />
          )}
        </div>
      </Tooltip>
    </>
  );
}
